import styled from 'styled-components';
export const NavbarWrapper =styled.div`
top:0;
float:right;
`;
